import React from 'react';
import { Collapse, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { ExpandMoreOutlined } from '@mui/icons-material';
import classNames from 'classnames';

interface Props {
  children: React.ReactNode;
}

const StyledLink = styled(Link)(({ theme }) => ({
  cursor: 'pointer',
  marginBottom: theme.spacing(1),
})) as typeof Link;

const StyledIcon = styled(ExpandMoreOutlined)(() => ({
  position: 'relative',
  top: 5,
  transition: 'transform 0.25s',
  [`&.open`]: {
    transform: 'rotate(180deg)',
  },
}));

export const ReadMore = ({ children }: Props) => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = React.useState<boolean>(false);

  return (
    <>
      {
        <StyledLink component={'div'} onClick={() => setShowMore(prev => !prev)}>
          <StyledIcon
            className={classNames({
              open: showMore,
            })}
          />
          <span>{t('common.tour_text_renderer.more')}</span>
        </StyledLink>
      }
      <Collapse in={showMore}>{children}</Collapse>
    </>
  );
};
